import { Collection } from 'modules/core/lib/mobx-rest'

import Filter from 'modules/reports/store/models/Filter'

class Filters extends Collection<Filter> {
  get cacheKey(): string {
    return 'filters'
  }

  model() {
    return Filter
  }
}

const singleton: Filters = new Filters()

export default singleton
